<template>
	<div class="form-content">
		<el-form ref="form" :model="form" :rules="rules" size="small" label-position="right" label-width="160px" :disabled="isEdit">
			<div class="form-row">
				<el-form-item label="工程名称" prop="gcmc" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.gcmc" placeholder="请输入工程名称" type="text"></el-input>
				</el-form-item>
			</div>

			<div class="form-row">
				<el-form-item label="工程地址" prop="gcdz" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.gcdz" placeholder="请输入工程地址" type="text"></el-input>
				</el-form-item>
			</div>

			<div class="form-row">
				<el-form-item label="合同编号" prop="htbh" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.htbh" placeholder="请输入合同编号" type="text"></el-input>
				</el-form-item>
				<el-form-item label="项目经理" prop="xmjl" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.xmjl" placeholder="请输入项目经理" type="text"></el-input>
				</el-form-item>
			</div>

			<div class="form-row">
				<el-form-item prop="pzwh" :inline-message="true" class="form-item" label-width="270px">
					<span slot="label">
						施工许可证号或开工报告批准文号
					</span>
					<el-input v-model.trim="form.pzwh" placeholder="请输入施工许可证号或开工报告批准文号" type="text"></el-input>
				</el-form-item>
			</div>

			<div class="form-row">
				<el-form-item prop="jzszsbh" :inline-message="true" class="form-item" label-width="180px">
					<span slot="label">
						建造师注册证书编号
					</span>
					<el-input v-model.trim="form.jzszsbh" placeholder="请输入建造师注册证书编号" type="text"></el-input>
				</el-form-item>
				<el-form-item prop="xmbm" :inline-message="true" class="form-item">
					<span slot="label">项目编码</span>
					<el-input v-model.trim="form.xmbm" placeholder="请输入项目编码" type="text"></el-input>
				</el-form-item>
			</div>

			<div class="form-row">
				<el-form-item label="工程简介" prop="gcjj" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.gcjj" placeholder="请输入工程简介" :rows="2" type="textarea"></el-input>
				</el-form-item>
			</div>

			<el-divider content-position="left">或工程起始地址 （线性工程填写）</el-divider>
			<div class="form-row">
				<el-form-item label="起始地址" prop="gcksdz" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.gcksdz" type="text">
						<template slot="prepend">自</template>
						<template slot="append">起</template>
					</el-input>
				</el-form-item>
				<el-form-item label="起始地址" prop="gcjsdz" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.gcjsdz" type="text">
						<template slot="prepend">至</template>
						<template slot="append">止</template>
					</el-input>
				</el-form-item>
			</div>

			<el-divider content-position="left">工程规模</el-divider>
			<div class="form-row">
				<el-form-item label="工程类别" prop="gclb" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.gclb" placeholder="请输入工程类别"></el-input>
				</el-form-item>
			</div>

			<div class="form-row">
				<el-form-item label="技术指标" prop="jszb" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.jszb" placeholder="请输入技术指标"></el-input>
				</el-form-item>
			</div>

			<div class="form-row">
				<el-form-item label="单位" prop="dw" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.dw" placeholder="请输入单位"></el-input>
				</el-form-item>
				<el-form-item label="数量" prop="sl" :inline-message="true" class="form-item amount">
					<el-input-number
						v-model="form.sl"
						controls-position="right"
						:precision="2"
						:step="0.1"
						:min="0"
						style="width: 100%;"
					></el-input-number>
				</el-form-item>
			</div>

			<div class="form-row">
				<el-form-item label="合同价（万）" prop="htj" :inline-message="true" class="form-item amount">
					<el-input-number
						v-model="form.htj"
						controls-position="right"
						:precision="6"
						:step="0.1"
						:min="0"
						style="width: 100%;"
					></el-input-number>
				</el-form-item>
				<el-form-item label="结算价（万）" prop="jsj" :inline-message="true" class="form-item amount">
					<el-input-number
						v-model="form.jsj"
						controls-position="right"
						:precision="6"
						:step="0.1"
						:min="0"
						style="width: 100%;"
					></el-input-number>
				</el-form-item>
			</div>

			<el-divider content-position="left">工程承包方式</el-divider>
			<div class="form-row">
				<el-form-item prop="gccbfs" label="工程承包方式" :inline-message="true" class="form-item">
					<el-checkbox-group v-model="form.gccbfs">
						<el-checkbox label="施工总承包"></el-checkbox>
						<el-checkbox label="专业施工承包"></el-checkbox>
						<el-checkbox label="工程总承包"></el-checkbox>
						<el-checkbox label="其它（需说明）"></el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item prop="sm" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.sm" placeholder="请输入说明"></el-input>
				</el-form-item>
			</div>

			<el-divider content-position="left">施工组织方式</el-divider>
			<div class="form-row">
				<el-form-item prop="sgzzfs" label="施工组织方式" :inline-message="true" class="form-item">
					<el-checkbox-group v-model="form.sgzzfs">
						<el-checkbox label="自行施工"></el-checkbox>
						<el-checkbox label="专业分包"></el-checkbox>
						<el-checkbox label="劳务分包"></el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</div>
			<div class="form-row">
				<el-form-item label="开工时间" prop="kgsj" :inline-message="true" class="form-item dataStyle">
					<el-date-picker
						v-model="form.kgsj"
						type="date"
						value-format="yyyy-MM-dd"
						placeholder="请选择开工时间"
						style="width: 100%;"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="竣工时间" prop="jgsj" :inline-message="true" class="form-item dataStyle">
					<el-date-picker
						v-model="form.jgsj"
						type="date"
						value-format="yyyy-MM-dd"
						placeholder="请选择竣工时间"
						style="width: 100%;"
					></el-date-picker>
				</el-form-item>
			</div>
			<el-divider></el-divider>

			<div class="form-row">
				<el-form-item label="计划工期（工作日）" prop="jhgq" :inline-message="true" class="form-item amount" label-width="180px">
					<el-input-number
						v-model="form.jhgq"
						controls-position="right"
						:precision="2"
						:step="0.1"
						:min="0"
						style="width: 100%;"
					></el-input-number>
				</el-form-item>
				<el-form-item label="实际工期（工作日）" prop="sjgq" :inline-message="true" class="form-item amount" label-width="180px">
					<el-input-number
						v-model="form.sjgq"
						controls-position="right"
						:precision="2"
						:step="0.1"
						:min="0"
						style="width: 100%;"
					></el-input-number>
				</el-form-item>
			</div>
			<div class="form-row">
				<el-form-item label="延误原因" prop="ywyy" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.ywyy" placeholder="请输入延误原因"></el-input>
				</el-form-item>
			</div>

			<div class="form-row">
				<el-form-item label="质量评定" prop="zlpd" :inline-message="true" class="form-item">
					<el-select v-model="form.zlpd" style="width: 100%">
						<el-option v-for="item in collection.zlpdxz" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="安全评价" prop="aqpj" :inline-message="true" class="form-item">
					<el-select v-model="form.aqpj" style="width: 100%">
						<el-option v-for="item in collection.aqpdxz" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
			</div>
			<div class="form-row">
				<el-form-item label="获奖情况" prop="hjqk" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.hjqk" placeholder="请输入获奖情况"></el-input>
				</el-form-item>
			</div>
			<div class="form-row">
				<el-form-item label="建设单位" prop="jsdw" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.jsdw" placeholder="请输入建设单位"></el-input>
				</el-form-item>
				<el-form-item label="建设单位联系人" prop="jsdwLxr" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.jsdwLxr" placeholder="请输入联系人"></el-input>
				</el-form-item>
			</div>
			<div class="form-row">
				<el-form-item label="建设单位联系电话" prop="jsdwLxdh" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.jsdwLxdh" placeholder="请输入联系电话"></el-input>
				</el-form-item>
				<el-form-item label="验收单位" prop="ysdw" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.ysdw" placeholder="请输入验收单位"></el-input>
				</el-form-item>
			</div>
			<div class="form-row">
				<el-form-item label="验收单位联系人" prop="ysdwLxr" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.ysdwLxr" placeholder="请输入联系人"></el-input>
				</el-form-item>
				<el-form-item label="验收单位联系电话" prop="ysdwLxdh" :inline-message="true" class="form-item">
					<el-input v-model.trim="form.ysdwLxdh" placeholder="请输入联系电话"></el-input>
				</el-form-item>
			</div>
		</el-form>
	</div>
</template>

<script>
	/**
	 * 工程业绩表单组件
	 */
	export default {
		name: 'EnterpriseProjectPerformance',
		components: {},
		data() {
			return {
				form: {
					id: '', // 表单id，编辑使用
					gcmc: '',
					gcdz: '',
					gcksdz: '',
					gcjsdz: '',
					htbh: '',
					pzwh: '',
					xmjl: '',
					jzszsbh: '',
					gcjj: '',
					gclb: '',
					jszb: '',
					dw: '',
					sl: '',
					htj: '',
					jsj: '',
					gccbfs: [],
					sm: '',
					sgzzfs: [],
					kgsj: '',
					jgsj: '',
					jhgq: '',
					sjgq: '',
					ywyy: '',
					zlpd: '',
					aqpj: '',
					hjqk: '',
					jsdw: '',
					jsdwLxr: '',
					jsdwLxdh: '',
					ysdw: '',
					ysdwLxr: '',
					ysdwLxdh: '',
					xmbm: '',
					extId: ''
				},
				rules: {
					gcmc: [{ required: true, message: '请输入工程名称', trigger: 'blur' }],
					gcdz: [{ required: true, message: '请输入工程地址', trigger: 'blur' }],
					gcksdz: [{ required: true, message: '请输入工程起始地址', trigger: 'blur' }],
					gcjsdz: [{ required: true, message: '请输入工程起始地址', trigger: 'blur' }],
					htbh: [{ required: true, message: '请输入合同编号', trigger: 'blur' }],
					pzwh: [{ required: true, message: '请输入施工许可证号或开工报告批准文号', trigger: 'blur' }],
					xmjl: [{ required: true, message: '请输入项目经理', trigger: 'blur' }],
					jzszsbh: [{ required: true, message: '请输入建造师注册证书编号', trigger: 'blur' }],
					xmbm: [{ required: true, message: '请输入项目编码', trigger: 'blur' }],
					gcjj: [{ required: true, message: '请输入工程简介', trigger: 'blur' }],
					gclb: [{ required: true, message: '请输入工程类别', trigger: 'blur' }],
					jszb: [{ required: true, message: '请输入技术指标', trigger: 'blur' }],
					dw: [{ required: true, message: '请输入单位', trigger: 'blur' }],
					sl: [{ required: true, message: '请输入数量', trigger: 'blur' }],
					htj: [{ required: true, message: '请输入合同价', trigger: 'blur' }],
					jsj: [{ required: true, message: '请输入结算价', trigger: 'blur' }],
					gccbfs: [{ required: true, message: '请选择工程承包方式', trigger: 'change' }],
					sgzzfs: [{ required: true, message: '请选择施工组织方式', trigger: 'change' }],
					kgsj: [
						{ required: true, message: '请选择开工时间', trigger: 'blur' },
						{ validator: this.startDate, trigger: 'blur' }
					],
					jgsj: [
						{ required: true, message: '请选择竣工时间', trigger: 'blur' },
						{ validator: this.endDate, trigger: 'blur' }
					],
					jhgq: [{ required: true, message: '请输入计划工期', trigger: 'blur' }],
					sjgq: [{ required: true, message: '请输入实际工期', trigger: 'blur' }],
					ywyy: [{ required: true, message: '请输入延误原因', trigger: 'blur' }],
					zlpd: [{ required: true, message: '请选择质量评定', trigger: 'change' }],
					aqpj: [{ required: true, message: '请选择安全评价', trigger: 'change' }],
					hjqk: [{ required: true, message: '请输入获奖情况', trigger: 'blur' }],
					jsdw: [{ required: true, message: '请输入建设单位', trigger: 'blur' }],
					jsdwLxr: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
					jsdwLxdh: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
					ysdw: [{ required: true, message: '请输入验收单位', trigger: 'blur' }],
					ysdwLxr: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
					ysdwLxdh: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
				},
				// 字典集合
				collection: {
					personOrInfoList: [],
					zlpdxz: [
						{
							value: '优良',
							label: '优良'
						},
						{
							value: '合格',
							label: '合格'
						},
						{
							value: '不合格',
							label: '不合格'
						}
					],
					aqpdxz: [
						{
							value: '优良',
							label: '优良'
						},
						{
							value: '合格',
							label: '合格'
						},
						{
							value: '不合格',
							label: '不合格'
						}
					]
				}
			}
		},
		props: {
			// 是否能编辑
			isEdit: {
				type: Boolean,
				default: false
			}
		},
		created() {},
		mounted() {},
		methods: {
			/**
			 * 验证表单起始时间规则
			 */
			// 起始日期验证
			startDate: function(rule, value, callback) {
				if (!value) {
					callback(new Error('起始日期不能为空！'))
				} else {
					// 如果结束日期没选，cb
					if (!this.form.jgsj) {
						callback()
					} else {
						// 结束日期有，进行判断
						if (this.compareDate(value, this.form.jgsj)) {
							// 如果起始在结束之前
							callback()
						} else {
							callback(new Error('起始日期不能在结束日期之后，请重新选择'))
						}
					}
				}
			},

			// 结束时间验证
			endDate(rule, value, callback) {
				if (!value) {
					callback(new Error('结束日期不能为空！'))
				} else {
					if (!this.form.kgsj) {
						callback()
					} else {
						// 起始日期有
						if (this.compareDate(this.form.kgsj, value)) {
							callback()
						} else {
							callback(new Error('结束日期不能在起始日期之前，请重新选择'))
						}
					}
				}
			},

			/**
			 * 比较两个日期
			 * @param start 起始日期
			 * @param end   结束日期
			 * @returns {boolean} true|false
			 */
			compareDate(start, end) {
				return new Date(end).getTime() > new Date(start).getTime()
			},
			// 表单保存操作（每个列表对应的表单组件必须添加此方法，且必须同名）
			handleSaveInfo() {
				return new Promise(resolve => {
					this.$refs.form.validate(valid => {
						if (valid) {
							resolve(this.form)
						}
					})
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/element-reset.scss';
	.form-content {
		.form-row {
			display: flex;
		}
		.form-item {
			flex: 1;
			margin-bottom: 15px;
			::v-deep {
				.el-input {
					input {
						padding: 0 15px 0 15px;
					}
				}
			}
		}

		.dataStyle {
			::v-deep {
				.el-input {
					input {
						padding: 0 15px 0 40px;
					}
				}
			}
		}

		.amount {
			::v-deep {
				.el-input {
					input {
						padding-left: 0px;
					}
				}
			}
		}

		::v-deep .el-input-number {
			.el-input-number__decrease,
			.el-input-number__increase {
				line-height: normal;
			}
		}
	}
</style>
